import { HtmlGraphicObject, createSvgAndSvgObjects, FixedDimension, ColorConverter } from "../../../../web-graphics";

function createPointsMeander(posX, posY, width, widthTop, height) {
  const widthBottom = (width - widthTop) / 2, // Left and right bottom lines width
    // Points coordinates
    x1 = posX,
    x2 = x1 + widthBottom,
    x3 = x2 + widthTop,
    x4 = x1 + width,
    y1 = posY,
    y2 = y1 - height;

  // Polyline string
  const ans = `
    ${x1},${y1}
    ${x2},${y1}
    ${x2},${y2}
    ${x3},${y2}
    ${x3},${y1}
    ${x4},${y1}`;

  return ans.trim();
}

// all values in pixels
export class Meander extends HtmlGraphicObject {
  constructor(settings) {
    super(Meander.setAdditionalSettings(settings));
    HtmlGraphicObject.setHtmlObject(this.settings, createSvgAndSvgObjects("g", ["class", `meander-${this.settings.windowName}`]));
    const colorParserResult = ColorConverter.convertWebglRgbaToHex(this.settings.style.color);
    this.settings.style.color = colorParserResult.success ? colorParserResult.value : "#000000";
    this.polylineMeander = createSvgAndSvgObjects(
      "polyline",
      [
        "points",
        createPointsMeander(
          this.settings.htmlObject.absoluteLocation.x,
          this.settings.htmlObject.absoluteLocation.y,
          this.settings.htmlObject.sizeInPixels.width,
          this.settings.widthTop,
          this.settings.htmlObject.sizeInPixels.height
        )
      ],
      ["stroke", this.settings.style.color],
      ["stroke-linecap", "round"],
      ["stroke-linejoin", "round"],
      ["fill", "none"],
      ["stroke-width", this.settings.style.lineWidth]
    );

    this.settings.htmlObject.ref.append(this.polylineMeander);
  }

  static setAdditionalSettings(settings) {
    settings.autoCalculateBordersFunc = Meander.autoCalculateBorders;
    return settings;
  }

  static autoCalculateY(settings) {
    return settings.htmlObject.parent.size.height -
    (settings.absoluteLocation.y -
      settings.htmlObject.graphicParent.settings.absoluteLocation.y +
      settings.htmlObject.graphicParent.settings.clientLocation.y) +
      settings.htmlObject.marginInPixels.top;
  }

  static autoCalculateBorders(settings) {
    HtmlGraphicObject.autoCalculateSize(settings);

    const htmlX = HtmlGraphicObject.autoCalculateX(settings);
    const htmlY = Meander.autoCalculateY(settings);
    settings.htmlObject.location = {
      x: new FixedDimension(htmlX),
      y: new FixedDimension(htmlY)
    };
  }

  // height: new ScalableDimension(0, 1)
  setHeight(height) {
    this.updateSize(this.settings.size.width, height);
  }

  updateMeanderPoints() {
    this.polylineMeander.setAttribute(
      "points",
      createPointsMeander(
        this.settings.htmlObject.absoluteLocation.x,
        this.settings.htmlObject.absoluteLocation.y,
        this.settings.htmlObject.sizeInPixels.width,
        this.settings.widthTop,
        this.settings.htmlObject.sizeInPixels.height
      )
    );
  }

  createHtmlBorders() {
    super.createHtmlBorders();
    this.updateMeanderPoints();
  }
}
